import { useMemo } from "react";

import { useGetMyMembershipsQuery } from "../api/rolesApi";

/**
 * Hook that fetches the current user's memberships and returns both the full list
 * and filtered lists for roles and teams.
 */
export function useMyMemberships(userId: string | undefined) {
  const queryResult = useGetMyMembershipsQuery(
    { userId: userId ?? "" },
    { skip: !userId },
  );

  const memberships = useMemo(() => queryResult.data ?? [], [queryResult.data]);
  const roles = useMemo(
    () => memberships.filter((item) => item.type === "role"),
    [memberships],
  );

  const teams = useMemo(
    () => memberships.filter((item) => item.type === "team"),
    [memberships],
  );

  return {
    ...queryResult,
    memberships,
    roles,
    teams,
  };
}
